// @ts-nocheck
import { createSelector } from 'reselect';
import { pick } from 'taptap-tools/utils';

import { getBaseCurrencyCatalog } from './resources.selectors';
import { getCurrentUser } from './user.selectors';

export const getModuleStore = store => store.baseCurrency;

export const getBaseCurrencies = createSelector([getModuleStore], moduleStore => moduleStore.baseCurrencies);

function formatBaseCurrency(baseCurrency) {
  return pick(baseCurrency, ['baseCurrency', 'currencySymbol', 'currencyPosition', 'countries']);
}

export const getCountryBaseCurrency = createSelector(
  [getModuleStore, (store, country) => country],
  (moduleStore, country) => {
    const { baseCurrencies } = moduleStore;
    const baseCurrency = baseCurrencies.find(baseCurrencyEntry => {
      return baseCurrencyEntry.countries && baseCurrencyEntry.countries.includes(country);
    });
    return formatBaseCurrency(
      baseCurrency ||
        baseCurrencies.find(baseCurrencyEntry => {
          return !baseCurrencyEntry.countries || baseCurrencyEntry.countries.length === 0;
        })
    );
  }
);

export const getBaseCurrency = createSelector(
  [getBaseCurrencyCatalog, (store, baseCurrency) => baseCurrency],
  (baseCurrencies, baseCurrency) => {
    const baseCurrencyFound = baseCurrencies.find(baseCurrencyEntry => {
      return baseCurrencyEntry.baseCurrency && baseCurrencyEntry.baseCurrency === baseCurrency;
    });
    return formatBaseCurrency(
      baseCurrencyFound ||
        baseCurrencies.find(baseCurrencyEntry => {
          return !baseCurrencyEntry.countries || baseCurrencyEntry.countries.length === 0;
        })
    );
  }
);

export const getSelectedUserBaseCurrency = createSelector(
  [getBaseCurrencies, getCurrentUser],
  (baseCurrencies, selectedUser) => {
    if (selectedUser) {
      const { currencyCountry } = selectedUser;
      const baseCurrency = baseCurrencies.find(baseCurrencyEntry => {
        return baseCurrencyEntry.countries && baseCurrencyEntry.countries.includes(currencyCountry);
      });
      return formatBaseCurrency(
        baseCurrency ||
          baseCurrencies.find(baseCurrencyEntry => {
            return !baseCurrencyEntry.countries || baseCurrencyEntry.countries.length === 0;
          })
      );
    }
    return null;
  }
);

export const getBaseCurrencyName = createSelector([getBaseCurrencies], baseCurrencies => {
  return baseCurrencies.length ? baseCurrencies[0].baseCurrency : '';
});
